import { useCallback, useEffect, useState } from "react";
import api from "@/lib/api";
import { btnLine } from "./shared";

const TONE = { critical: "border-l-coral text-coral", high: "border-l-coral/70 text-coral", attention: "border-l-brandyellow text-heading", info: "border-l-navy/30 text-muted" };
const LABEL = { critical: "Will be refused", high: "Likely problem", attention: "Check this", info: "Note" };

export default function Checks({ caseId, refreshKey }) {
  const [res, setRes] = useState(null);
  const load = useCallback(() => { api.get(`/cases/${caseId}/consistency`).then((r) => setRes(r.data)).catch(() => setRes(false)); }, [caseId]);
  useEffect(() => { load(); }, [load, refreshKey]);
  if (res === false) return <p className="text-sm text-muted">Checks could not be loaded.</p>;
  if (!res) return <div className="h-24 animate-pulse bg-white" />;
  return (
    <div data-testid="checks-panel">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-muted">We compare your forms, CV, dates, letters and documents against the causes of refusal seen in official guidance. This lists problems to fix; it does not predict the decision.</p>
        <button onClick={load} className={btnLine} data-testid="checks-rerun">Re-run checks</button>
      </div>
      {res.findings.length === 0 ? (
        <p className="mt-6 border border-navy/15 bg-white p-6 text-sm text-navy" data-testid="checks-clear">No inconsistencies found in what you entered. Upload every document, then re-run the checks.</p>
      ) : (
        <ul className="mt-6 space-y-3">
          {res.findings.map((f) => (
            <li key={f.id} className={`border border-navy/10 border-l-4 bg-white p-4 ${TONE[f.severity]}`} data-testid={`check-${f.id}`}>
              <p className="text-xs font-semibold uppercase tracking-wider">{LABEL[f.severity]} · {f.area}</p>
              <p className="mt-1 font-medium text-heading">{f.title}</p>
              <p className="mt-1 text-sm text-muted"><span className="font-medium text-navy">Why it matters:</span> {f.why}</p>
              <p className="mt-1 text-sm text-muted"><span className="font-medium text-navy">Fix:</span> {f.fix}</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
